import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import marketplacePtBR from './locales/pt-BR/marketplace.json';
import marketplacePtPT from './locales/pt-PT/marketplace.json';

// Portugal é o mercado de lançamento — pt-PT é o idioma ativo por padrão.
// pt-BR já vem preparado (mesmas chaves, conteúdo brasileiro) para quando o
// Brasil for lançado de facto; até lá não há seletor de idioma visível — só
// trocar `lng` aqui (ou ligar detecção por domínio) quando isso acontecer.
export const resources = {
  'pt-PT': { marketplace: marketplacePtPT },
  'pt-BR': { marketplace: marketplacePtBR },
} as const;

// Exportado pra `main.tsx` esperar antes de renderizar — mesmo com recursos
// estáticos (sem backend/http), a Promise de `.init()` só resolve depois de
// um tick, então `t()` chamado antes disso devolve a chave crua em vez do
// valor traduzido.
export const i18nReady = i18n.use(initReactI18next).init({
  resources,
  lng: 'pt-PT',
  fallbackLng: 'pt-PT',
  defaultNS: 'marketplace',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
